import React from 'react';

const Headline = ({ title, subtitle, alignment, style }) => {
  // This logic translates the simple choice from the dialog into the correct CSS classes.
  let baseClass = 'section-title';

  if (style === 'no-border') {
    // For 'No Border', we add the 'no-border' modifier class.
    baseClass = 'section-title no-border';
  } else if (style === 'large') {
    // For 'Large', we use the completely separate 'section-title-5' class.
    baseClass = 'section-title-5';
  }

  // Combine the determined base style with the alignment utility class.
  const finalClassName = [baseClass, alignment].filter(Boolean).join(' ');

  return (
    <div className={finalClassName}>
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </div>
  );
};

export default Headline;
